import { render, staticRenderFns } from "./SegmentationInsights.vue?vue&type=template&id=857699ce&scoped=true"
import script from "./SegmentationInsights.vue?vue&type=script&lang=js"
export * from "./SegmentationInsights.vue?vue&type=script&lang=js"
import style0 from "./SegmentationInsights.vue?vue&type=style&index=0&id=857699ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857699ce",
  null
  
)

export default component.exports